import React from "react";

const MTPmbok6 = (
  <div className="flex flex-row text-2xl items-center mb-4">
    <img className="mr-4" src="/images/pmbok6-icon.svg" width="45" />
    <span>PMBOK&#174; Guide &ndash; Sixth Edition</span>
  </div>
);
const MTpmbok7 = (
  <div className="flex flex-row text-2xl items-center mb-4">
    <img className="mr-4" src="/images/pmbok7-icon.svg" width="45" />
    <span>PMBOK&#174; Guide &ndash; Seventh Edition</span>
  </div>
);
const MTpmbokMtevm = (
  <div className="flex flex-row text-2xl items-center mb-4">
    <img className="mr-4" src="/images/pmbok-mtevm-icon.svg" width="45" />
    <span>The Standard for Earned Value Management</span>
  </div>
);
const MTpmo = (
  <div className="flex flex-row text-2xl items-center mb-4">
    <img className="mr-4" src="/images/pmopg-icon.svg" width="45" />
    <span>The Standard for Earned Value Management</span>
  </div>
);
const MTAPG = (
  <div className="flex flex-row text-2xl items-center mb-4">
    <img className="mr-4" src="/images/apg-icon.svg" width="45" />
    <span>Agile Practice Guide</span>
  </div>
);
const MTSPM = (
  <div className="flex flex-row text-2xl items-center mb-4">
    <img className="mr-4" src="/images/mtspm-icon.svg" width="45" />
    <span>The Standard for Program Management - Fifth Edition</span>
  </div>
);
const MTWBS = (
  <div className="flex flex-row text-2xl items-center mb-4">
    <img className="mr-4" src="/images/wbs-icon.svg" width="45" />
    <span>Practice Standard for WBS</span>
  </div>
);
const MTGBA = (
  <div className="flex flex-row text-2xl items-center mb-4">
    <img className="mr-4" src="/images/gba-icon.svg" width="45" />
    <span>Guide to Business Analysis</span>
  </div>
);
const MTSRM = (
  <div className="flex flex-row text-2xl items-center mb-4">
    <img className="mr-4" src="/images/gba-icon.svg" width="45" />
    <span>The Standards for Risk Management</span>
  </div>
);
const FragmentTitles = {
  MTpmbok7: MTpmbok7,
  MTAPG: MTAPG,
  MTWBS: MTWBS,
  MTGBA: MTGBA,
  MTSRM: MTSRM,
  MTSPM:MTSPM,
  MTPmbok6: MTPmbok6,
  MTEVM: MTpmbokMtevm,
  MTPMO: MTpmo
}

export default FragmentTitles;